import { UserServiceContext } from "@twii/ozone/lib/user/service/UserServiceContext";
import { RestUserService } from "@twii/ozone/lib/user/service/RestUserService";
import { UserDataServiceContext } from "@twii/ozone/lib/user/service/UserDataServiceContext";
import { RestUserDataService } from "@twii/ozone/lib/user/service/RestUserDataService";
import { ListingServiceContext } from "@twii/ozone/lib/listing/service/ListingServiceContext";
import { RestListingService } from "@twii/ozone/lib/listing/service/RestListingService";
import { ImageServiceContext } from "@twii/ozone/lib/media/service/ImageServiceContext";
import { RestImageService } from "@twii/ozone/lib/media/service/RestImageService";
import { UserAdminContext } from "@twii/ozone/lib/user/UserAdminContext";
import { isMemberOfGroup } from "@twii/ozone/lib/user/UserHelper";

const localOzone = (env : any) => {
    console.log("-- Applying Local Configuration");
    UserAdminContext.value = userProfile => {
        return isMemberOfGroup(userProfile, "APPS_MALL_STEWARD");
    };
    const apiBaseUrl = env["ozone.api.baseUrl"] || "http://localhost:8000/api";
    const iwcApiBaseUrl = env["ozone.iwc.api.baseUrl"] || "http://localhost:8000/iwc-api";
    const auth = {
        username: env["ozone.api.username"] || "bigbrother",
        password: env["ozone.api.password"] || "password"
    };
    const userService = new RestUserService();
    userService.baseUrl = apiBaseUrl;
    userService.auth = auth;
    UserServiceContext.value = userService;
    const userDataService = new RestUserDataService();
    userDataService.baseUrl = iwcApiBaseUrl;
    userDataService.auth = auth;
    UserDataServiceContext.value = userDataService;
    const listingService = new RestListingService();
    listingService.baseUrl = apiBaseUrl;
    listingService.auth = auth;
    ListingServiceContext.value = listingService;
    const imageService = new RestImageService();
    imageService.baseUrl = apiBaseUrl;
    imageService.auth = auth;
    ImageServiceContext.value = imageService;
};

export { localOzone, localOzone as default }